export default function initLanguageSelector() {
  const languageSelectorContainer = document.querySelector('.language-selector-container');
  const languageSelector = document.querySelector('.language-selector');
  const dropdown = document.querySelector('.language-selector-dropdown');

  if (!languageSelectorContainer || !languageSelector || !dropdown) return;

  let isOpen = false;

  function updateAriaStates() {
    languageSelector.setAttribute('aria-expanded', isOpen.toString());
    dropdown.setAttribute('aria-hidden', (!isOpen).toString());
  }

  function openDropdown() {
    isOpen = true;
    updateAriaStates();
  }

  function closeDropdown() {
    isOpen = false;
    updateAriaStates();
  }

  // Handle button focus
  languageSelector.addEventListener('focus', openDropdown);

  // Handle mouse hover
  languageSelectorContainer.addEventListener('mouseenter', openDropdown);
  languageSelectorContainer.addEventListener('mouseleave', (e) => {
    // Only close if we're not moving to a child element
    if (!languageSelectorContainer.contains(e.relatedTarget)) {
      closeDropdown();
    }
  });

  // Handle keyboard navigation
  languageSelector.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (isOpen) {
          // Focus first menu item
          const firstMenuItem = dropdown.querySelector('a[role="menuitem"]');
          if (firstMenuItem) {
            firstMenuItem.focus();
          }
        } else {
          openDropdown();
        }
        break;
      case 'Escape':
        closeDropdown();
        languageSelector.focus();
        break;
      case 'ArrowDown':
        e.preventDefault();
        openDropdown();
        const firstItem = dropdown.querySelector('a[role="menuitem"]');
        if (firstItem) {
          firstItem.focus();
        }
        break;
    }
  });

  // Handle focus leaving the entire component
  languageSelectorContainer.addEventListener('focusout', (e) => {
    // Check if focus is moving to an element outside the language selector
    setTimeout(() => {
      if (!languageSelectorContainer.contains(document.activeElement)) {
        closeDropdown();
      }
    }, 0);
  });

  // Handle menu item keyboard navigation
  dropdown.addEventListener('keydown', (e) => {
    const menuItems = Array.from(dropdown.querySelectorAll('a[role="menuitem"]'));
    const currentIndex = menuItems.indexOf(document.activeElement);

    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        closeDropdown();
        languageSelector.focus();
        break;
      case 'ArrowUp':
        e.preventDefault();
        if (currentIndex > 0) {
          menuItems[currentIndex - 1].focus();
        } else {
          languageSelector.focus();
        }
        break;
      case 'ArrowDown':
        e.preventDefault();
        if (currentIndex < menuItems.length - 1) {
          menuItems[currentIndex + 1].focus();
        }
        break;
      case 'Enter':
        // Explicitly trigger the link navigation
        if (document.activeElement && document.activeElement.tagName === 'A') {
          const link = document.activeElement;
          const href = link.getAttribute('href');
          if (href) {
            window.location.href = href;
          }
        }
        break;
      case 'Tab':
        // Allow normal tab behavior but close dropdown when tabbing out
        if (!e.shiftKey && currentIndex === menuItems.length - 1) {
          closeDropdown();
        } else if (e.shiftKey && currentIndex === 0) {
          closeDropdown();
        }
        break;
    }
  });

  // Initialize ARIA states
  updateAriaStates();
}
